// Turn on and off different animation elements for performance
// 1. import this file if a component has settings
// 2. add a setting here then select:
//    - true = on
//    - false = off

const window_width = window.innerWidth
const mobile_width = 600
const origin = document.location.origin
const location = (!origin.includes('localhost')) ? origin : 'http://thatdaynow.dev'

const Settings = {
   origin: origin,
   api: location+'/wp-json/wp/v2',
   acf: location+'/wp-json/acf/v3',
   animation: {
      // Allow animations for larger devices
      on: ( window_width > mobile_width ) ? true : false,
      // Main page animations
      gradients: false,
      parallax: false,
      scroll: true,
      scroll_indicators: false,
      scrollTo: true,
      // Header animations
      header_titles: true,
      header_orb: true,
      // Blur animations
      blur_images: true,
   },
}

export default Settings



// WEBPACK FOOTER //
// ./src/settings.js